import { Icons } from '@/components/icons';
import { Typography } from '@/components/primitives/Typography';
import { TransText } from '@/i18n/trans/text';
import type { BookingSearchDTO } from '@/types/dto/agent';
import { cn } from '@/utils/cn';
import type { FC } from 'react';

interface TravelPassSummaryProps {
  travelPassSummary: BookingSearchDTO['travelPassSummary'];
  description?: string;
  passengerCount?: number;
  isRefunded: boolean;
}

const TravelPassSummary: FC<TravelPassSummaryProps> = ({
  travelPassSummary,
  description,
  passengerCount,
  isRefunded,
}) => {
  return (
    <div className="flex flex-col gap-1">
      <div
        className={cn('flex flex-wrap items-center gap-x-2 text-primary', {
          'text-neutral': isRefunded,
        })}
      >
        <Typography variant="body1-bold">
          {travelPassSummary?.origin?.name}
        </Typography>
        <Icons.arrows className="h-4 w-4" />
        <Typography variant="body1-bold">
          {travelPassSummary?.destination?.name}
        </Typography>
      </div>
      <div className="flex gap-0.5">
        {description && (
          <Typography variant="body2" className="text-neutral">
            {description}
          </Typography>
        )}
        {description && passengerCount && (
          <Typography variant="body2" className="text-neutral">
            &#8226;
          </Typography>
        )}
        {passengerCount && (
          <>
            <Typography variant="body2" className="text-neutral">
              <TransText
                i18nKey="passengersCount"
                values={{ count: passengerCount }}
              />
            </Typography>
          </>
        )}
      </div>
    </div>
  );
};

export default TravelPassSummary;
